import { Select, Space, Tag } from "antd";
import { components } from "../types/OnuoGate";
import apiClient from "../services/ApiClient";
import { useState } from "react";

export default function SelectLogoDevice(_props: any) {
  const { onChange } = _props;
  const [logoSearchResults, setLogoSearchResults] = useState<
    components["schemas"]["LogoDevice"][]
  >([]);
  const [selectedLogoDevice, setSelectedLogoDevice] = useState<
    components["schemas"]["LogoDevice"] | null
  >(null);

  const logoSearchResultRenderer = (
    logoDevice: components["schemas"]["LogoDevice"],
  ) => {
    return (
      <table
        style={{
          width: "100%",
        }}
      >
        <tr>
          <td>{logoDevice.name}</td>
          <td>
            <Tag>{logoDevice.name2}</Tag>
          </td>
          <td>{logoDevice.specCode4}</td>
          <td>
            <Tag>{logoDevice.specCode5}</Tag>
          </td>
          <td>
            <Tag>{logoDevice.stgrpCode}</Tag>
          </td>
          <td>
            <Tag>{logoDevice.specCode3}</Tag>
          </td>
        </tr>
      </table>
    );
  };
  const handleLogoSearchResults = async (query: string) => {
    if (query.length > 2) {
      const response = await apiClient.searchLogoDevice({ handset: query });

      if (response.data) {
        setLogoSearchResults(
          response.data.map((x) => {
            return {
              ...x,
              key: x.logicalRef?.toString(),
              value: x.logicalRef,
            };
          }),
        );
      } else {
        setLogoSearchResults([]);
      }
    } else {
      setLogoSearchResults([]);
    }
  };

  return (
    <Select
      autoClearSearchValue={false}
      filterOption={(inputValue, option) => {
        return true;
      }}
      showSearch
      onSearch={handleLogoSearchResults}
      options={logoSearchResults}
      labelRender={(props) => {
        console.log("selected", props, selectedLogoDevice);
        return (
          <div>
            {selectedLogoDevice && logoSearchResultRenderer(selectedLogoDevice)}
          </div>
        );
      }}
      onChange={(value, option) => {
        if (option) {
          // @ts-expect-error `option` is not `null`
          onChange(option.value);

          // @ts-expect-error: `option` is not `null`
          setSelectedLogoDevice(option);
        }
      }}
      optionRender={(oriOption, info) => {
        return <Space>{logoSearchResultRenderer(oriOption.data)}</Space>;
      }}
      dropdownRender={(menu) => {
        return <div>{menu}</div>;
      }}
    ></Select>
  );
}
